/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUserCouponHistory
 */
export interface ControlcenterMelcoModelsUserCouponHistory {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserCouponHistory
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserCouponHistory
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsUserCouponHistory
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserCouponHistory
     */
    product_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsUserCouponHistory
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsUserCouponHistory
     */
    redeemed_on?: Date | null;
}

export function ControlcenterMelcoModelsUserCouponHistoryFromJSON(json: any): ControlcenterMelcoModelsUserCouponHistory {
    return ControlcenterMelcoModelsUserCouponHistoryFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUserCouponHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUserCouponHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'redeemed_on': !exists(json, 'redeemed_on') ? undefined : (json['redeemed_on'] === null ? null : new Date(json['redeemed_on'])),
    };
}

export function ControlcenterMelcoModelsUserCouponHistoryToJSON(value?: ControlcenterMelcoModelsUserCouponHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'user_id': value.user_id,
        'product_code': value.product_code,
        'amount': value.amount,
        'redeemed_on': value.redeemed_on === undefined ? undefined : (value.redeemed_on === null ? null : value.redeemed_on.toISOString()),
    };
}


